import styled from 'styled-components';
import theme from 'styled-theming';
import { Popover } from '@sede-enterprise/shell-ds-react-framework';

export const backgroundColor = theme('name', {
  light: '#fff',
  dark: 'rgb(52, 52, 52)',
});

export const backgroundColorTR = theme('name', {
  light: 'rgb(242, 242, 242)',
  dark: '#FFFFFF17',
});

export const TableContainer = styled.div`
  position: relative;
  min-height: 400px;
  .table-container {
    border-radius: 5px 5px 0 0;
    display: flex;
    overflow: auto;
    max-height: calc(100vh - 375px);

    tr:nth-child(even) {
      background-color: ${backgroundColorTR};
    }
    thead th {
      padding: 16px;
      background-color: ${backgroundColorTR};
    }
  }
  .shell-table {
    width: 100%;
  }
  thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: ${backgroundColor};
  }
  .pagination-container {
    display: flex;
    justify-content: end;
    align-items: center;
    margin-top: 20px;
  }
  .select-page-size {
    width: 100px;
    margin-left: 10px;
  }
  .total-rows {
    margin-right: 10px;
  }
  .no-data-cell {
    padding: 170px 20px;
    .title_wrapper {
      display: flex;
      justify-content: center;
    }
  }
`;

export const ColumnTitleContainer = styled.div`
  display: flex;
  .sorting-wrapper {
    display: flex;
    .shell-table-column-title {
      display: flex;
      align-items: center;
    }
    button {
      width: 20px;
    }
  }
  .filter-tooltip_button {
    opacity: 0;
    width: 0 !important;
    height: 0;
  }

  button svg {
    height: 16px !important;
    width: 16px !important;
  }
`;

export const FilterContainer = styled.div`
  max-width: 170px;
  padding: 10px;
  font-size: 12px;
  font-weight: 600;

  .space {
    margin: 5px 0;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    button {
      min-height: 25px;
      font-size: 13px;
      :nth-child(1) {
        margin-right: 5px;
      }
    }
  }

  &.date-time {
    max-width: 210px;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;

  &.wrapper-height {
    height: 50%;
  }
  .loader-wrapper {
    background-color: ${(props) => props.theme.background.surface};
    padding: 15px;
    border-radius: 4px;
  }
`;

export const FilterPopover = styled(Popover)`
  z-index: 3;
  div:has(form) {
    border-radius: 5px;
  }
`;
